import { Point } from "highcharts";
import moment from "moment/moment";
import {
  dateFromUtcByTimeZone,
  formatDate,
} from "@/utils/helpers/date-time/datetime-format";
import { getTooltipOptions } from "@/storybook/c8r-highcharts/common/utils/tooltip/getTooltipOptions";
import { offHoursChartLabels } from "@/components/pages/recommendations/components/off-hours-recommendations/components/table/subrow/charts/helpers/generateOffHoursHighChartData";

const tooltipMarkupGenerator = (point: Point) => {
  const timestamp = formatDate(
    dateFromUtcByTimeZone(`${point.category}`) || moment(),
    { type: "dateTime" },
  );

  const cpuSeries = point.series?.chart?.series.find(
    (series) => series.name === offHoursChartLabels.cpu,
  ) as any;

  const offHoursSeries = point.series?.chart?.series.find(
    (series) => series.name === offHoursChartLabels.recommendedHours,
  ) as any;

  const cpu = cpuSeries?.userOptions?.data?.[point.x];
  const offHours = offHoursSeries?.userOptions?.data?.[point.x];

  const color = cpuSeries?.userOptions?.color;

  return `
        <div style="
          font-size: 12px;
          font-weight: 500;
          color: #9E9E9E;
          margin-bottom: 6px;
        ">
          ${offHours ? "Underutilised " : "Utilised "}period
        </div>
        
        <div style="font-size: 12px; color: #000; margin-bottom: 4px;">
          ${timestamp}
        </div>
        
        <div style="display: flex; align-items: center; font-size: 12px; color: #000;">
        <span style="display:inline-block; width:4px; height:16px; border-radius:2px; background:${color}; margin-right:6px;"></span>
          CPU ${cpu?.toFixed(2) + "%"}
        </div>
    `;
};

export const offHoursChartTooltipOptions = getTooltipOptions({
  tooltipMarkupGenerator,
});
